const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

const dateTimeFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

export const formatCurrency = (
  value: number | string | null | undefined,
): string => formatCurrencyINR(value);

export function formatCurrencyINR(
  value: number | string | null | undefined,
): string {
  const amount = typeof value === "string" ? Number(value) : value;

  if (amount == null || Number.isNaN(amount)) {
    return inrFormatter.format(0);
  }

  return inrFormatter.format(amount);
}

export function formatDate(value: Date | string | null | undefined): string {
  if (!value) {
    return "-";
  }

  return dateFormatter.format(new Date(value));
}

export function formatDateTime(
  value: Date | string | null | undefined,
): string {
  if (!value) {
    return "-";
  }

  return dateTimeFormatter.format(new Date(value));
}
